import { render, staticRenderFns } from "./trainingPlan.vue?vue&type=template&id=423a303f&scoped=true"
import script from "./trainingPlan.vue?vue&type=script&lang=js"
export * from "./trainingPlan.vue?vue&type=script&lang=js"
import style0 from "./trainingPlan.vue?vue&type=style&index=0&id=423a303f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a303f",
  null
  
)

export default component.exports